import React from "react";
import styled from "styled-components";


const SummaryButton = ({setOpen, open}) => {

    const toggleHandler = () => {
        setOpen(!open)
    }

    return (
        <Button onClick={toggleHandler}>
            <svg width="50" height="50" viewBox="0 0 31 25" fill={open ? "yellow" : "red"} xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M0.290527 5.3652C0.290527 2.60378 2.5291 0.365204 5.29053 0.365204L25.2905 0.365204C28.052 0.365204 30.2905 2.60378 30.2905 5.3652V19.3652C30.2905 22.1266 28.052 24.3652 25.2905 24.3652H5.29053C2.5291 24.3652 0.290527 22.1266 0.290527 19.3652L0.290527 5.3652Z"
                    fill={open ? "white" : "#4909AA"}/>
                <path
                    d="M8.1728 17.0266L8.15651 15.9113L21.027 15.7233L21.0433 16.8386L8.1728 17.0266ZM24.9398 15.8149L20.2106 12.3699L24.8127 8.80719L25.8887 9.59097L22.3392 12.3388L25.9924 15L24.9398 15.8149ZM8.11524 13.0857L8.09895 11.9704L17.9993 11.8258L18.0156 12.9411L8.11524 13.0857ZM8.05877 9.21922L8.04248 8.10388L20.913 7.9159L20.9293 9.03124L8.05877 9.21922Z"
                    fill={open ? "#4909AA" : "white"}/>
            </svg>
        </Button>
    )
}


const Button = styled.div`
  &:hover {
    cursor: pointer;

    svg {
      fill: yellow;

      path {
        fill: white;
      }

      path:last-of-type {
        fill: #4909AA;
      }
    }
  }
`

export default SummaryButton;